/**
 * Where in the browser a client error was caught.
 *
 * A LEAF module with no imports of its own, and exported from the package on its own subpath, so the
 * one consumer that lives in the browser can reach it without the wide-events barrel coming too.
 *
 * That matters more than it looks. The barrel re-exports `context`, which builds an
 * `AsyncLocalStorage` at module scope, and the event modules which reach for other Node built-ins —
 * so a browser bundle that touches the barrel gets Vite's externalized stubs and throws on import:
 *
 *   Module "node:crypto" has been externalized for browser compatibility.
 *
 * `portals/src/lib/data.ts` builds a zod enum from this list at module scope, and the i18n hook pulls
 * that module into every route, so importing it from the barrel took out every page in dev.
 *
 * Kept as ONE list because three consumers must agree on it: the `client_error` event, that zod enum
 * validating the browser's report, and the Jira select option. The enum has no `.catch()`, so a value
 * sent but not listed fails validation and loses the whole report.
 */
export const CLIENT_ERROR_SOURCES = [
	'uncaught',
	'boundary',
	'unhandledrejection',
	'global',
	'hydration',
	'recoverable',
] as const;

export type ClientErrorSource = (typeof CLIENT_ERROR_SOURCES)[number];
